import {isCurrentLogInInfoValid, user} from "./Security";
import {
    ajaxJSONWithoutWait,
    getCustomerSupportAlertPeriod,
    getCustomerSupportEndDate,
    isEmptyOrNull,
    isNotEmptyOrNull,
    isNullOrUndefined
} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import {getName, isEnglish} from "../common/Translator";
import {timedQueryChanged} from "../views/Navbar";
import {calcForecolor, themesWidgetBaseColors_} from "../common/GUIUtilities";
import {currentLoginInfo} from "./LoginPresenter";

let notifactionPeriod = 5 * 1000;
let inProgress = false;
let remainingSupportDays = null;
let supportEndDate = null;
let customerSupportAlertPeriod;

function onTimedQueryResultChanged(results) {
    let text = "";
    if (isNotEmptyOrNull(results)) {
        for (let result of results) {
            let value = result.value;
            if (isNullOrUndefined(value) || value === "null")
                value = "";
            text += getName(result.arabic, result.english);
            if (value !== "template$$")
                text += ":" + value + " ";
        }
    }
    checkSupportDateIfNeeded(text);
}

export function scheduleTimedQuery() {
    if (inProgress)
        return;
    if (!isCurrentLogInInfoValid())
        return;
    if (!currentLoginInfo().timedQuery)
        return;

    if (currentLoginInfo().timedQueryDelayInSeconds && currentLoginInfo().timedQueryDelayInSeconds > 0)
        notifactionPeriod = currentLoginInfo().timedQueryDelayInSeconds;
    else
        notifactionPeriod = 20;
    let timedQueryId = currentLoginInfo().timedQuery.id;
    inProgress = true;
    ajaxJSONWithoutWait(urls.ExecuteTimedQuery, {
            "timedQueryId": timedQueryId
        }, (result) => {
            inProgress = false;
            onTimedQueryResultChanged(result.data.results);
            setTimeout(() => scheduleTimedQuery(), notifactionPeriod);
        }, () => {
            inProgress = false;
            setTimeout(() => scheduleTimedQuery(), notifactionPeriod);
            return false;
        }
    );
}


function getSupportDateAlerts() {
    try {
        if (!user())
            return "";
        if (user().settings.doNotDisplayCriticalErrors === true)
            return "";
        if (user().fullProfile && user().fullProfile.doNotDisplayCriticalErrors === true)
            return "";
        if (remainingSupportDays === null) {
            supportEndDate = getCustomerSupportEndDate();
            if (isEmptyOrNull(supportEndDate))
                return "";
            remainingSupportDays = new Date(supportEndDate).getTime() - new Date().getTime();
            remainingSupportDays = remainingSupportDays / (24 * 60 * 60 * 1000);
            customerSupportAlertPeriod = getCustomerSupportAlertPeriod();
        }

        if (customerSupportAlertPeriod <= 0)
            return "";
        let translatedError = "";
        if (remainingSupportDays < 0)
            translatedError = isEnglish() ? "Support expired on" : "انتهت الصيانة في ";
        else if (remainingSupportDays < customerSupportAlertPeriod)
            translatedError = isEnglish() ? "Support will expire on" : "ستنتهي الصيانة في ";
        if (isNotEmptyOrNull(translatedError))
            return "<div id ='supportEndDate'>" + translatedError + " " + supportEndDate + "</div>";
    } catch (e) {
        console.error(e);
        return "";
    }
    return "";
}

export function checkSupportDateIfNeeded(timedQueryText) {
    let text = "";
    if (isNotEmptyOrNull(timedQueryText)) {
        let timedQueryForeColor = calcForecolor(themesWidgetBaseColors_());
        text = `<div style="color:${timedQueryForeColor};"> ${timedQueryText} </div>`;
    }
    text += getSupportDateAlerts();
    if (isNotEmptyOrNull(text))
        timedQueryChanged(text);
}